import { SxProps } from '@mui/material'

export const absoluteMaxSizeStyles: SxProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
}

export const dialogStyles: SxProps = { width: { xs: 1, sm: 500 } }
